import { type IconName } from '@aspendental/shared-components-web';
import { mountStoreDevtool } from 'simple-zustand-devtools';
import { create } from 'zustand';

export type State = {
	appointmentDialogOpen: boolean;
	focusedAppointmentPatientSpeciesIcon: IconName;
	focusedAppointmentPatientName: string;
	focusedAppointmentStartTime: string;
	focusedAppointmentReasonForVisit: string;
	focusedAppointmentLocation: string;
	focusedAppointmentLocationAddress: string;
};

type Actions = {
	setAppointmentDialogOpen: (open: boolean) => void;
	setFocusedAppointmentPatientSpeciesIcon: (speciesIcon: IconName) => void;
	setFocusedAppointmentPatientName: (patientName: string) => void;
	setFocusedAppointmentStartTime: (startTime: string) => void;
	setFocusedAppointmentReasonForVisit: (reasonForVisit: string) => void;
	setFocusedAppointmentLocation: (location: string) => void;
	setFocusedAppointmentLocationAddress: (address: string) => void;
};

const useUserPortalStore = create<State & Actions>((set) => ({
	appointmentDialogOpen: false,
	focusedAppointmentPatientName: '',
	focusedAppointmentPatientSpeciesIcon: 'LVOtherPet',
	focusedAppointmentStartTime: '',
	focusedAppointmentReasonForVisit: '',
	focusedAppointmentLocation: '',
	focusedAppointmentLocationAddress: '',
	setFocusedAppointmentPatientSpeciesIcon: (focusedAppointmentPatientSpeciesIcon: IconName) =>
		set({ focusedAppointmentPatientSpeciesIcon }),
	setAppointmentDialogOpen: (appointmentDialogOpen) => set({ appointmentDialogOpen }),
	setFocusedAppointmentPatientName: (focusedAppointmentPatientName) => set({ focusedAppointmentPatientName }),
	setFocusedAppointmentStartTime: (focusedAppointmentStartTime) => set({ focusedAppointmentStartTime }),
	setFocusedAppointmentReasonForVisit: (focusedAppointmentReasonForVisit) =>
		set({ focusedAppointmentReasonForVisit }),
	setFocusedAppointmentLocation: (focusedAppointmentLocation) => set({ focusedAppointmentLocation }),
	setFocusedAppointmentLocationAddress: (focusedAppointmentLocationAddress) =>
		set({ focusedAppointmentLocationAddress }),
}));

if (process.env.NODE_ENV === 'development') {
	mountStoreDevtool('useUserPortalStore', useUserPortalStore);
}

export default useUserPortalStore;
